import { styled } from "@mui/material/styles";
import { TableCell, tableCellClasses } from "@mui/material";
const StyledTableCell = styled(TableCell)(({ theme, isBordered }) => ({
    border: "none",
    padding: "25px",
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#FCEEE8",
        color: theme.palette.bgBlack.main,
        textTransform: "uppercase",
        fontFamily: "Satoshi-Bold",
        fontSize: "16px",
        whiteSpace: "nowrap",
    },
    [`&.${tableCellClasses.body}`]: {
        color: theme.palette.bgBlack.main,
        fontFamily: "Satoshi-Light",
        fontSize: "15px",
        borderRight: isBordered ? "1px solid #0000001a" : "",
        "&:last-child": {
            borderRight: "none",
        },
    },
}));
export default StyledTableCell;
